import { c as _c } from "react/compiler-runtime";
import { ArrowUpRight01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { cn } from "@matsuricon/ui/utils";
import Link from "next/link";
import { mobileDepthClass } from "./mobile-nav-styles";
import type { NavLeaf } from "./navigation-data";
import { isCurrentPath } from "./navigation-utils";
type MobileLeafLinkProps = {
  item: NavLeaf;
  depth: number;
  pathname: string;
  onNavigate: () => void;
};
export function MobileLeafLink(t0) {
  const $ = _c(20);
  const {
    item,
    depth,
    pathname,
    onNavigate
  } = t0;
  let current;
  let t1;
  if ($[0] !== depth || $[1] !== item.external || $[2] !== item.href || $[3] !== pathname) {
    current = !item.external && isCurrentPath(pathname, item.href);
    t1 = cn("flex min-h-11 items-center gap-2 rounded-md pr-3 font-medium text-muted-foreground transition-[background-color,color] hover:bg-muted hover:text-foreground", mobileDepthClass(depth), current && "bg-muted text-primary");
    $[0] = depth;
    $[1] = item.external;
    $[2] = item.href;
    $[3] = pathname;
    $[4] = current;
    $[5] = t1;
  } else {
    current = $[4];
    t1 = $[5];
  }
  const className = t1;
  let t2;
  if ($[6] !== item.label) {
    t2 = <span className="min-w-0 flex-1">{item.label}</span>;
    $[6] = item.label;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== item.external) {
    t3 = item.external ? <HugeiconsIcon aria-hidden="true" icon={ArrowUpRight01Icon} strokeWidth={1.8} /> : null;
    $[8] = item.external;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const content = t4;
  let t5;
  if ($[13] !== className || $[14] !== content || $[15] !== current || $[16] !== item.external || $[17] !== item.href || $[18] !== onNavigate) {
    t5 = item.external ? <a className={className} href={item.href} onClick={onNavigate}>{content}<span className="sr-only"> (external site)</span></a> : <Link aria-current={current ? "page" : undefined} className={className} href={item.href} onClick={onNavigate}>{content}</Link>;
    $[13] = className;
    $[14] = content;
    $[15] = current;
    $[16] = item.external;
    $[17] = item.href;
    $[18] = onNavigate;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}